export const getNodeByPath = (root: Node, path: number[]): Node | null => {
  let current: Node | null = root;

  for (const index of path) {
    const hasChildNodes = current?.childNodes;
    const isIndexValid = index >= 0 && index < (current?.childNodes?.length ?? 0);

    if (!hasChildNodes || !isIndexValid) {
      return null;
    }

    current = current.childNodes[index];
  }

  return current;
};
